import { BiometricsPermissionPage } from './pages/biometrics-permission/BiometricsPermission.page'

import type { RouteObject } from 'react-router-dom'

const biometricRoutes: RouteObject[] = [
  {
    path: 'biometric',
    element: (
      // <ProtectedBiometricRoute>
      <BiometricsPermissionPage />
      // </ProtectedBiometricRoute>
    ),
  },
]

export { biometricRoutes }
